import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import { Trans } from "@/plugins/Translation";
import Unauthorized from "../views/Auth/Unauthorized.vue";
import Callback from "../views/Auth/Callback.vue";
import CategoriesIndex from "@/views/Categories/Index.vue";
import CategoriesEdit from "@/views/Categories/Edit.vue";
import RequestEdit from "@/views/Request/Edit.vue";
import RequestCompleted from "@/views/Request/Completed.vue";
import RequestDetail from "@/views/Request/Detail.vue";
import GAApi from "../api/GA/GAApi";

const routes = [
    {
        path: "/:lang",
        component: {
            template: "<router-view></router-view>"
        },
        beforeEnter: Trans.routeMiddleware,
        children: [
            {
                path: "/",
                name: "home",
                component: Home,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "Categories/Index",
                name: "CategoriesIndex",
                component: CategoriesIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "Categories/Edit/:Id?",
                name: "CategoriesEdit",
                component: CategoriesEdit,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "Request/Edit/:Id?",
                name: "RequestEdit",
                component: RequestEdit,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "Request/Completed",
                name: "RequestCompleted",
                component: RequestCompleted,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "Request/Detail/:Id?",
                name: "RequestDetail",
                component: RequestDetail,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "details/:Id?",
                name: "datails",
                component: RequestDetail,
                meta: {
                    requiresAuth: true
                }
            }, 
            {
                path: "/about",
                name: "about",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: About,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "callback",
                name: "callback",
                component: Callback,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
        ]
    },
    {
        // Redirect user to supported lang version.
        path: "*",
        // eslint-disable-next-line
        redirect(to) {
            return Trans.getUserSupportedLang();
        }
    },
    {
        path: "unauthorized",
        name: "unauthorized",
        beforeEnter(to, from, next) {
            GAApi.GetAccessDeniedPage().then(result => {
                window.location.replace(result.data.Url);
            });
        },
        meta: {
            requiresAuth: false
        }
    }
];

export default routes;
